import { ThemeProps } from '@hhgtech/hhg-components'
import styled from 'styled-components'

export const StyledCardSkeleton = styled.div`
  & > div {
    width: 100%;
    min-height: 109px;
  }
`

export const StyledCard = styled.div`
  min-height: 116px;
  padding: 8px;
  border: 1px solid ${(props: ThemeProps) => props.theme.colors.neutral100};
  background-color: ${(props: ThemeProps) => props.theme.colors.white};
  border-radius: 6px;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.04), 0px 0px 2px rgba(0, 0, 0, 0.06),
    0px 0px 1px rgba(0, 0, 0, 0.04);
  text-align: center;
  transition: 0.2s ease-in-out;

  &[data-is-active='true'] {
    background-color: ${(props: ThemeProps) => props.theme.colors.primaryBase};
    p {
      color: ${(props: ThemeProps) => props.theme.colors.white};
    }
  }

  & > :last-child {
    margin-top: 8px;
  }
`

export const StyledCardHref = styled.a`
  min-height: 116px;
  padding: 8px;
  border: 1px solid ${(props: ThemeProps) => props.theme.colors.neutral100};
  background-color: ${(props: ThemeProps) => props.theme.colors.white};
  border-radius: 6px;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.04), 0px 0px 2px rgba(0, 0, 0, 0.06),
    0px 0px 1px rgba(0, 0, 0, 0.04);
  text-align: center;
  text-decoration: none;
  transition: 0.2s ease-in-out;

  &[data-is-active='true'] {
    background-color: ${(props: ThemeProps) => props.theme.colors.primaryBase};
    p {
      color: ${(props: ThemeProps) => props.theme.colors.white};
    }
  }

  & > :last-child {
    margin-top: 8px;
  }
`
